import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import LogoAdmin from "../assets/img/LogoAdmin.png";
import Pacientes from "../Components/Admin/Pacientes";
import Historiales from "../Components/Admin/Historiales";
import Inicio from "../Components/Admin/Inicio";
import Horarios from "../Components/Admin/Horarios";
import Sidebar from "../Components/Admin/Sidebar";
import PacienteHistorial from "../Components/Admin/PacienteHistorial";

const AdminPage = () => {
  const { user, logout, isAuthLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("Inicio");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedPaciente, setSelectedPaciente] = useState(null);


  useEffect(() => {
    if (!isAuthLoading && !user) {
      console.log("Redirigiendo a login...");
      navigate("/login");
    }
  }, [isAuthLoading, user, navigate]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderSection = () => {
    switch (activeSection) {
      case "Inicio":
        return <Inicio idUsuario={user.id} />;
      case "Horarios":
        return <Horarios idUsuario={user.id} />;
      case "Historiales":
        return <Historiales setSelectedPaciente={setSelectedPaciente} setActiveSection={setActiveSection} />;
      case "Pacientes":
        return <Pacientes  setSelectedPaciente={setSelectedPaciente} setActiveSection={setActiveSection}/>;
      case "PacienteHistorial":
        return <PacienteHistorial dni_paciente={selectedPaciente} setSelectedPaciente={setSelectedPaciente} setActiveSection={setActiveSection}/>;
      default:
        return <p>Seleccione una sección</p>;
    }
  };

  return user ? (
    <div className="d-flex">
      {/* Sidebar para pantallas grandes */}
      {!isMobile && <Sidebar setActiveSection={setActiveSection} logout={logout} />}
      {/* Barra superior */}
      <div className="flex-grow-1">
        {isMobile && (
          <nav className="navbar navbar-dark bg-primary d-flex justify-content-between px-3">
            <img src={LogoAdmin} alt="Logo" style={{ height: "50px" }} />
            <button className="btn btn-light" onClick={() => setMenuOpen(!menuOpen)}>
              <i className="bi bi-list"></i>
            </button>
          </nav>
        )}

        {/* Menú desplegable para móviles */}
        {isMobile && menuOpen && (
          <div className="bg-primary text-white p-3 position-absolute w-100" style={{ zIndex: 1000 }}>
            <ul className="nav flex-column">
              <li className="nav-item" onClick={() => { setActiveSection("Inicio"); setMenuOpen(false); }}>
                <span className="nav-link text-white">Inicio</span>
              </li>
              <li className="nav-item" onClick={() => { setActiveSection("Horarios"); setMenuOpen(false); }}>
                <span className="nav-link text-white">Horarios</span>
              </li>
              <li className="nav-item" onClick={() => { setActiveSection("Historiales"); setMenuOpen(false); }}>
                <span className="nav-link text-white">Historiales</span>
              </li>
              <li className="nav-item" onClick={() => { setActiveSection("Pacientes"); setMenuOpen(false); }}>
                <span className="nav-link text-white">Pacientes</span>
              </li>
              <li className="nav-item mt-3">
                <button className="btn btn-danger w-100" onClick={logout}>Cerrar Sesión</button>
              </li>
            </ul>
          </div>
        )}
{/* Contenido principal */}
<div className={`flex-grow-1 p-0 ${isMobile ? 'overflow-x-hidden' : 'overflow-auto'} m-0`} style={{ maxHeight: "100vh", maxWidth: "100vw" }}>
          {renderSection()}
        </div>
      </div>
    </div>
  ) : null;
};

export default AdminPage;
